import FolderSharedRoundedIcon from "@mui/icons-material/FolderSharedRounded";
import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Grid,
  Modal,
  Paper,
  Switch,
  TextField,
  Typography,
  styled
} from "@mui/material";
import PaymentRoundedIcon from "@mui/icons-material/PaymentRounded";
import ReceiptRoundedIcon from "@mui/icons-material/ReceiptRounded";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { decode } from "base-64";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../api";
import { fetchToken } from "../auth/Token";
import "../card.css";


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: "groove",
  border: "3px",
  borderColor: "grey",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)",
  marginTop: "10px",
  minHeight: "50px",
  borderRadius: "10px",
}));

export const Subscriptions = (isOnline) => {
    const [current_subs, setCurrent_subs] = useState([]);
    const [other_subs, setOther_subs] = useState([]);
    const [subsc_modal, setsubsc_modal] = useState(false);
    const [edit_data, setEdit_data] = useState([]);
    const [edit_mode, setEdit_mode] = useState(false);
    const [salary_fill, setSalary_fill] = useState([]);
    const [amount, setAmount] = useState(null);
    const [society, setSociety] = useState([]);
    const [bank_accounts, setBank_accounts] = useState([]);
    const [selected_bank, setSelected_bank] = useState(null);
    const [expense_accounts, setExpense_accounts] = useState([]);
    const [selected_expense, setSelected_expense] = useState(null);
    const [open_new, setOpen_new] = useState(false);
    const location = useLocation();
    const society_id = location.state && location.state.society_id;
    const name = location.state && location.state.name;
    const [using_others, setUsing_others] = useState(false);
    const [mainT, setMainT] = useState(false);
    const [main_account, setMain_account] = useState([]);

    const handleMain = () => {
      setSelected_bank(main_account?.Main?.id);
      setMainT(true)
    }

    const editSubscription = (row) => {
      setEdit_mode(true);
      setEdit_data(row)
      setOpen_new(true)
      formik.setFieldValue("asset_name", row.asset_name)
      formik.setFieldValue("date_acquired", row.date_acquired)
      formik.setFieldValue("asset_value", row.asset_value)
      formik.setFieldValue("asset_type", row.asset_type)
      formik.setFieldValue("description", row.description)
      formik.setFieldValue("depreciation_period", row.depreciation_period)
      formik.setFieldValue("asset_status", row.asset_status)
      formik.setFieldValue("user_assigned", row.user_assigned)
      formik.setFieldValue("asset_id", row.id)
    }
  
    const closeNew = () => {
      setOpen_new(false);
      formik.handleReset();
      setEdit_mode(false);
      setEdit_data([]);
    };
  

    const formik = useFormik({
      initialValues: {
        society_id: society_id,
        subscription_id: null,
        description: "",
        title: "",
        months: null,
        email: "",
        phone: "",
        account_provider: "",
        account_number: "",
        account_name: "",
      },
      onSubmit: (values) => {
        const newData = new FormData();
        newData.append("title", values.title);
        newData.append("description", values.description);
        newData.append("society_id", values.society_id);
        newData.append("months", values.months);
        newData.append("description", values.description);
        newData.append("email", values.email);
        newData.append("phone", values.phone);
        newData.append("account_provider", values.account_provider);
        newData.append("account_number", values.account_number);
        newData.append("account_name", values.account_name);
  
  
        if (values.subscription_id !== null) {
          newData.append("subscription_id", values.subscription_id);
        }
  
        toast.promise(
          api.post("/users/save/new/subscription", newData, {
            headers: {
              Authorization: "Bearer " + fetchToken(),
            },
          }),
          {
            loading: edit_mode?"Updating Subscription...": "Adding New Subscription... ",
            success: (response) => {
              closeNew();
              getSubscriptionData();
  
              return response.data;
            },
            error: (error) => {
              console.log(error);
  
              return "An error occurred, Please refresh.";
            },
          }
        );
      },
    });
  
    const printWaybill = (id) => {
      toast.promise(
        api.get(`/users/generate/subscription/invoice/${id}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
          responseType: "blob",
        }),
        {
          loading: "Generating invoice...",
          success: (response) => {
            // Create a URL for the blob
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const a = document.createElement('a');
            a.href = url;
            a.download = `Invoice_${id}.pdf`; 
            document.body.appendChild(a);
            a.click(); // Trigger the download
            a.remove(); // Clean up
  
            return "Invoice generated successfully!";
  
          },
          error: (error) => {
            console.log(error);
  
            return "Error, Please Refresh page";
          },
        }
      )
    }
  
    const pay_subscription = () => {
      const data = new FormData()
      data.append("society_id", society_id)
      data.append("paye_subsc_id", salary_fill?.id)
      data.append("expense_id", selected_expense)
      if(using_others){
        data.append("amount", amount)
      }
      
      toast.promise(
        api.post(using_others?"/users/pay/subsc/value_chain" : "/users/pay/subsc", data, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        }),
        {
          loading: "Processing payment...",
          success: (response) => {
            closeSubscModal();
            getSubscriptionData();
  
            return response.data;
  
          },
          error: (error) => {
            console.log(error);
  
            return "Error, Please Refresh page";
          },
        }
      )
    }

    const confirmPayment = (id) => {
        toast.promise(
            api.post(`/users/developer/confirm/${id}`, {
              headers: {
                Authorization: "Bearer " + fetchToken(),
              },
            }),
            {
              loading: "Changing Status...",
              success: (response) => {
                closeSubscModal();
                getSubscriptionData();
      
                return response.data;
      
              },
              error: (error) => {
                console.log(error);
      
                return "Error, Please Refresh page";
              },
            }
          )
    }

    const closeSubscModal = () => {
      setsubsc_modal(false);
      setSalary_fill([]);
      setAmount(null);
      setSociety([]);
      setBank_accounts(null);
      setSelected_bank(null);
      setSelected_expense(null);
      setUsing_others(false);
      setMainT(false)
    }
  
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "90%",
      maxHeight: "80vh",
      minHeight: "70vh",
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "7px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
      bgcolor: "background.paper",
      borderRadius: "7px",
      boxShadow: 24,
      p: 4,
    };
    
    const style1 = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "50%",
      maxHeight: "80vh",
      minHeight: "70vh",
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "7px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
      bgcolor: "background.paper",
      borderRadius: "7px",
      boxShadow: 24,
      p: 4,
    };
  
    const openPaySalary = (row, id) => {
      setsubsc_modal(true);
      setSalary_fill(row);
      setUsing_others(id)
    }
  
    const pic = (pic) => {
      const de = decode(pic);
      return `data:image/jpeg;base64,${btoa(de)}`;
    };
  
    const getSubscriptionData = () => {
      toast.promise(
        api.get(`/users/subscription/data/${society_id}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        }),
        {
          loading: "Fetching...",
          success: (response) => {
            setCurrent_subs(response.data.user_subs);
            setOther_subs(response.data.others);
  
            return "Data Loaded Successfully";
          },
          error: (error) => {
            console.log(error);
  
            return "Error, Please Refresh page";
          },
        }
      );
      
      toast.promise(
        api.get("/users/subscriptions/data/update", {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        }),
        {
          loading: "Fetching...",
          success: (response) => {
  
            return "Data Loaded Successfully";
          },
          error: (error) => {
            console.log(error);
  
            return "Error, Please Refresh page";
          },
        }
      );
      
      toast.promise(
        api.get("/users/all/subscriptions/data/update", {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        }),
        {
          loading: "Fetching...",
          success: (response) => {
  
            return "Data Loaded Successfully";
          },
          error: (error) => {
            console.log(error);
  
            return "Error, Please Refresh page";
          },
        }
      );

      toast.promise(
        api.get(`/account/society/all/expense/${society_id}`, {
            headers: {
            Authorization: "Bearer " + fetchToken(),
            },
        }),
        {
            loading: 'Loading bank accounts...',
            success: (response) => {
                setBank_accounts(response.data?.Banks);
                setExpense_accounts(response.data?.Accounts);
                setMain_account(response.data);
  
                return 'Loaded Successfully'
            },
            error: (error) => {
                console.log(error);
  
                return 'An error occurred, Please try again'
            }
        }
      )
    };
  
    useEffect(() => {
      getSubscriptionData();
    }, []);

  
    function formatDateToYearMonth(date) {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const month = months[date.getMonth()];
      const year = date.getFullYear();
  
      return `${month} ${year}`;
    }
  
    
    const currencyFormat = new Intl.NumberFormat('en-GH', {
      style: 'currency',
      currency: 'GHS',
    });

  return (
    <div className="app">
      <main className="content">
        <Box sx={{ m: 3 }}>
          <Typography
            sx={{ textAlign: "center" }}
            variant="h3"
            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
          >
            <b>Subscriptions</b>
          </Typography>
          <Typography
            sx={{ textAlign: "center" }}
            variant="h5"
            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
          >
            <b>{name}</b>
          </Typography>
          <Box>
            <Button
              size="small"
              color="success"
              variant="contained"
              sx={{
                m: 3,
                borderRadius: 2,
                boxShadow:
                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                "&:hover": {
                  boxShadow:
                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                  backgroundColor: "#14213d",
                },
              }}
              onClick={() => setOpen_new(true)}
            >
              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>New Subscription</b>
              </Typography>
            </Button>
          </Box>
          
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <Typography variant="h4" sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>Softwares</b>
              </Typography>
              <Box
                sx={{
                  overflow: "auto",
                  marginBottom: 10,
                  maxHeight: 540,
                  "&::-webkit-scrollbar": {
                    width: "7px",
                    height: "7px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#888",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    background: "#555",
                  },
                }}
              >
                <Table size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>No.</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Date</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Status</b>
                        </Typography>{" "}
                      </TableCell>
                      <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Pay</b>
                        </Typography>{" "}
                      </TableCell>
                      {/* <TableCell align="left">
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Invoice</b>
                        </Typography>{" "}
                      </TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {current_subs?.map((row, index) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          "&:last-child td, &:last-child th": {
                            border: 0,
                          },
                          backgroundColor: "#f5f3f4",
                        }}
                      >
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{index + 1}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{formatDateToYearMonth(new Date(row.date_month))}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography sx={{ color:row.status === 'Unpaid'?'red': row.status === 'Pending'? 'blue':'green' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{row.status}</b>
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <Button
                                  size="small"
                                  color="success"
                                  variant="contained"
                                  disabled={row.status === "Paid" || row.status === "Pending"}
                                  sx={{
                                    borderRadius: 2,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                    },
                                  }}
                                  onClick={() => openPaySalary(row, false)}
                                >
                                  <PaymentRoundedIcon />
                                </Button>
                              </Typography>
                            </TableCell>
                            {/* <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <Button
                                  size="small"
                                  color="success"
                                  variant="contained"
                                  disabled={row.status === "Unpaid"}
                                  sx={{
                                    borderRadius: 2,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                    },
                                  }}
                                  onClick={() => printWaybill(row.id)}
                                >
                                  <ReceiptRoundedIcon />
                                </Button>
                              </Typography>
                            </TableCell> */}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Grid>
            {
              other_subs?.map((subscription_bag) => (
                <Grid item xs={12} md={6}>
                   <Typography variant="h4" sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>{subscription_bag.title}</b>
                    </Typography>
                  <Box
                    sx={{
                      overflow: "auto",
                      marginBottom: 10,
                      maxHeight: 540,
                      "&::-webkit-scrollbar": {
                        width: "7px",
                        height: "7px",
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        background: "#888",
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb:hover": {
                        background: "#555",
                      },
                    }}
                  >
                    <Table size="small" aria-label="a dense table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>No.</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Date</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Status</b>
                            </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Pay</b>
                            </Typography>{" "}
                          </TableCell>
                          {/* <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Invoice</b>
                            </Typography>{" "}
                          </TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {subscription_bag?.subs?.map((row, index) => (
                          <TableRow
                            key={row.id}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                              backgroundColor: "#f5f3f4",
                            }}
                          >
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{index + 1}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{formatDateToYearMonth(new Date(row.date_month))}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography sx={{ color:row.status === 'Unpaid'?'red': row.status === 'Pending'? 'blue':'green' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.status}</b>
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <Button
                                      size="small"
                                      color="success"
                                      variant="contained"
                                      disabled={row.status === "Paid" || row.status === "Pending"}
                                      sx={{
                                        borderRadius: 2,
                                        boxShadow:
                                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        "&:hover": {
                                          boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                          backgroundColor: "#14213d",
                                        },
                                      }}
                                      onClick={() => openPaySalary(row, true)}
                                    >
                                      <PaymentRoundedIcon />
                                    </Button>
                                  </Typography>
                                </TableCell>
                                {/* <TableCell align="left">
                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <Button
                                      size="small"
                                      color="success"
                                      variant="contained"
                                      disabled={row.status === "Unpaid"}
                                      sx={{
                                        borderRadius: 2,
                                        boxShadow:
                                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        "&:hover": {
                                          boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                          backgroundColor: "#14213d",
                                        },
                                      }}
                                      onClick={() => printWaybill(row.id)}
                                    >
                                      <ReceiptRoundedIcon />
                                    </Button>
                                  </Typography>
                                </TableCell> */}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
                </Grid>
              ))
            }
          </Grid>

          
          {/* table box end here */}

        </Box>

        <Modal
          open={open_new}
          onClose={closeNew}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style1}>
            <Grid container spacing={1}>
              <Grid xs={12} md={12}>
                <Typography
                  sx={{ textAlign: "center" }}
                  variant="h3"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                  <b>{edit_mode? "Update Subscription": "Register New Subscription"}</b>
                </Typography>
              </Grid>
              <Grid item xs={12} md={12}>
                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    required
                    name="title"
                    type="text"
                    value={formik.values.title}
                    onChange={formik.handleChange}
                    placeholder="Subscription Title"
                    helperText="Subscription Title"
                    fullWidth
                  />

                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    required
                    name="months"
                    type="number"
                    value={formik.values.months}
                    onChange={formik.handleChange}
                    placeholder="Billing Period (in months)"
                    helperText="Billing Period (in months)"
                    fullWidth
                  />
                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    name="email"
                    type="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    placeholder="Contact Email (responsible contact for payment)"
                    helperText="Contact Email (responsible contact for payment)"
                    fullWidth
                  />
                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    name="phone"
                    type="text"
                    value={formik.values.phone}
                    onChange={formik.handleChange}
                    placeholder="Contact Phone (responsible contact for payment)"
                    helperText="Contact Phone (responsible contact for payment)"
                    fullWidth
                  />
                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    name="description"
                    type="text"
                    multiline
                    rows={4}
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    placeholder="Description (model, product year, seller details...)"
                    helperText="Description (model, product year, seller details...)"
                    fullWidth
                  />
                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    name="account_provider"
                    type="text"
                    value={formik.values.account_provider}
                    onChange={formik.handleChange}
                    placeholder="Account Provider (MTN/FIDELITY BANK ....)"
                    helperText="Account Provider (MTN/FIDELITY BANK ....)"
                    fullWidth
                  />
                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    name="account_name"
                    type="text"
                    value={formik.values.account_name}
                    onChange={formik.handleChange}
                    placeholder="Account Name"
                    helperText="Account Name"
                    fullWidth
                  />
                  <TextField
                    sx={{ m: 0.5 }}
                    size="small"
                    name="account_number"
                    type="text"
                    value={formik.values.account_number}
                    onChange={formik.handleChange}
                    placeholder="Account Number"
                    helperText="Account Number"
                    fullWidth
                  />
                
              </Grid>

              <Grid item xs={12} md={8}></Grid>
              <Grid item xs={12} md={4}>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Button
                    size="small"
                    color="error"
                    variant="contained"
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                    onClick={closeNew}
                  >
                    Cancel
                  </Button>

                  <Button
                    size="small"
                    color="success"
                    variant="contained"
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                    onClick={formik.handleSubmit}
                  >
                    {edit_mode?"Complete update":"Complete Registration"}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Modal>
        
        <Modal
              open={subsc_modal}
              onClose={closeSubscModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                      <Typography variant="h3" sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Subscription Payment</b>
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Item>
                        <Box sx={{display:'flex', flexDirection:'row', justifyContent:'space-around'}}>
                          <Box>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>{!using_others?"The Cooperative":`Subscription Title: ${salary_fill?.title}`}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>{!using_others?"The Cooperative Facilitator":`Description: ${salary_fill?.description}`}</b>
                            </Typography>
                            {
                              !using_others?
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>TheCoopFacilitator (Mobile App)</b>
                              </Typography>
                              :null
                            }
                            
                          </Box>
                          {/* <Divider variant='middle' sx={{ m:1 }} orientation="vertical" flexItem/> */}
                          <Box>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Contact Phone: {!using_others?"0530125669/0509687490":salary_fill?.phone}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Email: {!using_others?"afrifabusiness518@gmail.com":salary_fill?.email}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Address: Accra, Ghana</b>
                            </Typography>
                            <Divider sx={{ m:.5 }}/>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Account Provider: {!using_others?"MTN/TELECEL":salary_fill?.account_provider}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Account Name: {!using_others?"YAW ANKAMAH AFRIFA":salary_fill?.account_name}</b>
                            </Typography>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>MOMO Number: {!using_others?"0530125669/0509687490":salary_fill?.account_number}</b>
                            </Typography>
                            {
                              !using_others?
                              <>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Bank Account Provider: FIDELITY BANK GH.</b>
                                </Typography>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Bank Account Name: YAW ANKAMAH AFRIFA</b>
                                </Typography>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Bank Account Number: 2400326997919</b>
                                </Typography>
                              </>
                              :null
                            }
                            
                            
                          </Box>
                        </Box>
                      </Item>
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                      <Item>
                        <Typography sx={{ textAlign:'center' }} variant="h2" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Monthly Subscription: {currencyFormat.format(!using_others?1200:amount)}</b>
                        </Typography>
                        {
                          !using_others?
                            <>
                              <Divider variant='middle' sx={{ m:1 }} />
                              <Box sx={{display:'flex', flexDirection:'row', justifyContent:'space-around'}}>
                                  {/* <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Value Chain Contributions: <span style={{ color:'red' }}>{currencyFormat.format(200)}</span></b>
                                  </Typography> */}
                              </Box>
                              {/* <Divider variant='middle' sx={{ m:1 }} /> */}
                              <Typography sx={{ textAlign:'center', color:'green', my:10.5 }} variant="h1" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Total Amount: {currencyFormat.format(1200)}</b>
                              </Typography>
                            </>
                          :<>
                            <TextField
                                sx={{ m: 0.5 }}
                                size="small"
                                required
                                name="amount"
                                type="number"
                                inputProps={{ step: 'any' }}
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                placeholder="Subscription amount"
                                helperText="Subscription amount"
                                fullWidth
                              />
                          </>
                        }
                        
                      </Item>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Item>
                        <Box sx={{ display:'flex' }}>
                          
                          
                          <Autocomplete
                            id="tags-outlined"
                            options={expense_accounts}
                            sx={{ width:'30%' }}
                            getOptionLabel={(option) => option.account_name}
                            isOptionEqualToValue={(option, value) =>
                                option.account_name === value.id
                            }
                            onChange={(event, value) =>
                              setSelected_expense(value.id)
                            }
                            filterSelectedOptions
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                helperText="Ledger to save record"
                                size="small"
                            />
                            )}
                          />

                          <Button
                            size="small"
                            color="error"
                            variant="contained"
                            sx={{
                            borderRadius: 2,
                            m: 1,
                            boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            "&:hover": {
                                boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                backgroundColor: "#14213d",
                            },
                            }}
                            onClick={closeSubscModal}
                          >
                            Close
                          </Button>

                          <Button
                            size="small"
                            color="success"
                            variant="contained"
                            sx={{
                            borderRadius: 2,
                            m: 1,
                            boxShadow:
                                "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                            "&:hover": {
                                boxShadow:
                                "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                backgroundColor: "#14213d",
                            },
                            }}
                            onClick={pay_subscription}
                            disabled={!selected_expense}
                          >
                            Complete Payment
                          </Button>
                        </Box>

                      </Item>
                    </Grid>
                </Grid>
            </Box>
          </Modal>
        
      </main>
    </div>
  );
};
